import { Injectable } from '@angular/core';
import { TarjetaModel } from './ciudadanos/models/tarjeta.model';

export enum ListType {
  NEGRA = 0,
  BLANCA = 1,
  MASTER = 2,
  INDEFINIDO = 3,
}

export enum Type {
  VIRTUAL = 0,
  FISICA = 1,
  APP = 2,
}

export type TarjetaListItem = TarjetaModel & {
  listType: ListType;
  type: Type;
  listTypeLabel: string;
  typeLabel: string;
};

@Injectable({
  providedIn: 'root'
})
export class TarjetaListTransformerService {

  private readonly LIST_TYPE_LABEL: Record<number, string> = {
    [ListType.MASTER]: 'Master',
    [ListType.BLANCA]: 'Blanca',
    [ListType.NEGRA]: 'Negra',
    [ListType.INDEFINIDO]: 'Indefinido',
  };

  private readonly TYPE_LABEL: Record<number, string> = {
    [Type.VIRTUAL]: 'Virtual',
    [Type.FISICA]: 'Física',
    [Type.APP]: 'App',
  };

  public transform(tarjeta: TarjetaModel): TarjetaListItem {
    const listTypeNum = tarjeta.tipo;

    const typeNum = tarjeta.virtual ? Type.VIRTUAL :
                    !tarjeta.virtual ? Type.FISICA :
                    Type.APP;

    return {
      ...tarjeta,

      listType: listTypeNum,
      type: typeNum,
      listTypeLabel: this.LIST_TYPE_LABEL[listTypeNum],
      typeLabel: this.TYPE_LABEL[typeNum],
      master: undefined,
      virtual: undefined,
    };
  }
}
